// /src/collections-rep-dgrm/color-palette.ts
// Scalable, deterministic colors for any number of categories.

const CB_SAFE_12 = [
  '#1b9e77',
  '#d95f02',
  '#7570b3',
  '#e7298a',
  '#66a61e',
  '#e6ab02',
  '#a6761d',
  '#666666',
  '#1f78b4',
  '#b2df8a',
  '#fb9a99',
  '#fdbf6f',
];

// Simple, stable string→int hash (FNV-1a-ish)
function hashInt(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = (h * 16777619) >>> 0;
  }
  return h >>> 0;
}

// Build N visually distinct colors: first 12 are colorblind-safe, rest are HSL-spread
export function buildPalette(n: number): string[] {
  if (n <= CB_SAFE_12.length) return CB_SAFE_12.slice(0, n);
  const out = [...CB_SAFE_12];
  for (let i = out.length; i < n; i++) {
    const hue = Math.round((360 * i) / n);
    out.push(`hsl(${hue}, 65%, 55%)`);
  }
  return out;
}

// Deterministic color for an id across renders/filters
export function colorFor(id: string | number, total: number, palette?: string[]): string {
  const p = palette ?? buildPalette(Math.max(12, total));
  const idx = hashInt(String(id)) % p.length;
  return p[idx];
}
